import React, { ReactNode } from 'react';

import { Moment } from 'shared/components/internal/Moment';

export type SchemaVersionType = 'legacy' | 'v3';

export type RecordRendererType = (
  value: ReactNode,
  record: RecordType
) => ReactNode;

export interface RecordInfoRendererType {
  [name: string]: RecordRendererType;
}

export interface RecordType {
  [key: string]: any;
}

export interface LabeledPropertyType {
  label: string;
  name: string;
  value: string | number | boolean | null;
}

export interface RecordColumnValueType {
  primary?: string;
  secondary?: string;
  renderer?: (value: ReactNode, record: RecordType) => ReactNode;
  secondaryRenderer?: (value: ReactNode, record: RecordType) => ReactNode;
}

export interface RecordColumnMapType {
  [name: string]: RecordColumnValueType[];
}

export const DateRenderer = (value: any) => (
  <Moment unix={true}>{value}</Moment>
);

export const ParsedDateRenderer = (value: any) => (
  <Moment format='L' unix={true}>
    {value}
  </Moment>
);

export const ParsedTimeRenderer = (value: any) => (
  <Moment format='h:mm a' unix={true}>
    {value}
  </Moment>
);

export const getRecordSchemaVersion = (record: any) => {
  let schemaVersion: SchemaVersionType = 'legacy';

  if (
    (record.hasOwnProperty('metadata_schemaVersion') &&
      record.metadata_schemaVersion === 3) ||
    (record.hasOwnProperty('objectType') && record.objectType)
  ) {
    schemaVersion = 'v3';
  }

  return schemaVersion;
};
